'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleDebugTool = exports.enableDebugTools = undefined;

var _debugConstants = require('./debugConstants');

var _debugUtil = require('./debugUtil');

// Constants
var enableDebugTools = exports.enableDebugTools = function enableDebugTools() {
    (0, _debugUtil.enableDebug)();
    return {
        type: _debugConstants.ENABLE_DEBUG_TOOLS
    };
};

// Utils
var toggleDebugTool = exports.toggleDebugTool = function toggleDebugTool(_ref) {
    var enabled = _ref.enabled,
        toolName = _ref.toolName;
    return {
        type: _debugConstants.DEBUG_TOOL_TOGGLE,
        enabled: enabled,
        toolName: toolName
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/debugActions.js
// module id = 719
// module chunks = 0